// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nm-0";
export var assigneeDetails = "_nm-1";
export var assigneeInfo = "_nm-2";
export var dropdownContainer = "_nm-4";
export var dropdownImage = "_nm-5";
export var editAssigneeInfo = "_nm-3";
export var editAssigneeModalContainer = "_nm-6";
export var hidden = "_nm-8";
export var input = "_nm-7";